'use strict';

var cov_2rp1d8rdmc = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Copyright/lib/Copyright.js',
      hash = '0bc9ebb0383e50eeb651bfd5f6dd3034c6cf084a',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Copyright/lib/Copyright.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 10,
          column: 1
        }
      },
      '1': {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 15,
          column: 1
        }
      },
      '2': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 70
        }
      },
      '3': {
        start: {
          line: 17,
          column: 0
        },
        end: {
          line: 22,
          column: 2
        }
      },
      '4': {
        start: {
          line: 24,
          column: 0
        },
        end: {
          line: 26,
          column: 2
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 13,
            column: 18
          },
          end: {
            line: 13,
            column: 19
          }
        },
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 70
          }
        },
        line: 14
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    f: {
      '0': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  box-sizing: border-box;\n  position: relative;\n  color: inherit;\n  display: contents;\n'], ['\n  box-sizing: border-box;\n  position: relative;\n  color: inherit;\n  display: contents;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = (cov_2rp1d8rdmc.s[0]++, _styledComponents2.default.p(_templateObject));

/** Component to display the copyright, the year and the holder of copyright */
cov_2rp1d8rdmc.s[1]++;
var Copyright = function Copyright(_ref) {
  var holder = _ref.holder,
      year = _ref.year;
  cov_2rp1d8rdmc.f[0]++;
  cov_2rp1d8rdmc.s[2]++;
  return _react2.default.createElement(
    Wrapper,
    null,
    String.fromCharCode(169) + ' ' + year + ' ' + holder
  );
};

cov_2rp1d8rdmc.s[3]++;
Copyright.propTypes = {
  /** The name of the copyright holder */
  holder: _propTypes2.default.string.isRequired,
  /** The name of the copyright holder */
  year: _propTypes2.default.string
};

cov_2rp1d8rdmc.s[4]++;
Copyright.defaultProps = {
  year: new Date().getFullYear().toString()
};

exports.default = Copyright;